export default __webpack_public_path__ + "static/media/notification-bulk-reveal.63dcb653.svg";